import { makeStyles } from "@/ui/kit/styles/makeStyles";

export default makeStyles()((theme) => ({
  header: {
    position: "relative",
    textAlign: "center",
    minHeight: 48,
  },
  hasBottomGutter: {
    "&+.MuiDialogContent-root": {
      paddingTop: theme.spacing(2.5),
    },
  },
  headerTitle: {
    position: "relative",
    top: 4,
  },
  startIcon: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    left: 16,
    padding: theme.spacing(0.5),
  },
  endIcon: {
    display: "inline-flex",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: 16,
    color: theme.palette.text.secondary,
  },
}));
